app.controller('subTaskListController', ['$scope', 'stateService', 'executionService', 'workflowThemeService', 'imageService', 'userStepDataService', function ($scope, stateService, executionService, workflowThemeService, imageService, userStepDataService) {
    $scope.initialize = function () {
        $scope.workflowThemeService = workflowThemeService;
        $scope.themeColor = workflowThemeService.getColor();
        $scope.imageService = imageService;
    };
    $scope.initialize();
}])